import type { ItemAttributes } from '.';

export enum VIDEO_TYPE_ATTRIBUTE {
  LINK = 'link',
  UPLOADED_FILE = 'uploadedFile',
}

export interface VideoItemAttributes extends ItemAttributes {
  type: VIDEO_TYPE_ATTRIBUTE;
  videoUrl: string;
  videoImageSrc: string;
}
